export const PublicNavebarData = [
    {   
        name:'Home',
        icon:'',
        path:'/home',
    },
    // {   
    //     name:'About Us',
    //     icon:'',
    //     path:'/about-us',
    // },
    {   
        name:'Blog',
        icon:'',
        path:'/blog',
    },
    {   
        name:'Projects',
        icon:'',
        path:'/projects',
    },
    {   
        name:'Our Services',
        icon:'',
        path:'/services',
    },
    {   
        name:'Contact Us',
        icon:'',
        path:'/contactUs',
    },

]